import { GlobalProps } from "./GlobalProps";

export function isArray(obj) {
    return !!obj && obj.constructor === Array;
}
export function isObject(obj) {
    return typeof obj == "object";
}

const stringIsGlobalFunction = (s) => {
    let str = (s || "").replaceAll(" ", "");
    let ind0 = str.indexOf("(");
    let ind1 = str.indexOf(")");
    let res = "";
    if (ind0 >= 0 && ind1 > ind0) {
        res = str.substr(0, ind0);
        if (typeof window[res] == "function") {
            return true;
        }
    }
    return false;
}
export class ObjectUtils {
    public static evalAllProperty = (obj, rootObj, needEvalFunc, currDeep, maxDeep) => {
        if (typeof obj !== "object") return;
        if (currDeep > maxDeep) return;
        if (isArray(obj)) {
            for (let item of obj) {
                ObjectUtils.evalAllProperty(item, rootObj, needEvalFunc, currDeep + 0, maxDeep);
            }
        }
        else {
            for (let key in obj) {
                if (typeof obj[key] == "object") {
                    ObjectUtils.evalAllProperty(obj[key], rootObj, needEvalFunc, currDeep + 1, maxDeep);
                }
                else if (typeof obj[key] == "string" && obj[key]) {
                    let functionAsString = obj[key];
                    try {
                        let resFunc0 = GlobalProps[functionAsString];
                        if (!resFunc0) {
                            resFunc0 = eval(functionAsString);
                            if (stringIsGlobalFunction(functionAsString)) {
                                obj[key] = resFunc0;
                                continue;
                            }
                        }
                        if (typeof resFunc0 == "function") {
                            if (needEvalFunc) {
                                try {
                                    let resFuncFinal = resFunc0(obj, rootObj);
                                    obj[key] = resFuncFinal;
                                }
                                catch {

                                }
                            }
                            else {
                                obj[key] = resFunc0;
                            }
                        }
                    }
                    catch {

                    }
                }
            }
        }
    }

}